const fnPath = (folder: string) => ([name, href = "/"]: string[]) => ({
  name,
  href,
  image: require(`@/assets/logo-partners/${folder}/${name}.png`)
});

export const PARTNERS = [
  // {
  //   type: "BANK & TRUST",
  //   list: [
  //     ["Signature Bank", "https://www.signatureny.com/"],
  //     ["Metropolitan", "https://www.metropolitanbankny.com/"]
  //   ].map(fnPath("Bank Trust"))
  // },
  {
    type: "CRYPTOCURRENCY EXCHANGES & WALLETS",
    list: [
      ["Kucoin", "https://www.kucoin.com/"],
      ["Gate", "https://www.gate.io/en/"],
      ["Deribit", "https://www.deribit.com/"],
      ["OKX", "https://www.okex.com/"],
      ["Phemex", "https://phemex.com/"],
      ["Bitrue", "https://www.bitrue.com/"],
      ["ProBit", "https://www.probit.com/en-us/"],
      ["LBANK", "https://www.lbank.info/"],
      ["BitMart", "https://www.bitmart.com/"],
      ["Cobo Wallet", "https://cobo.com/"],
      ["CoinTiger", "https://www.cointiger.com/en-us/#/index"],
      ["Xbank", "https://xbank.plus/"],
      ["XT", "https://www.xt.com/"],
      ["ZB", "https://www.zb.com/"],
      ["Mexo", "https://www.mexo.io/"],
      ["TokenPocket", "https://www.tokenpocket.pro/en"],
      ["Tbitex", "https://www.tbitex.com/"],
      ["Valens Exchange", "https://valens-exchange.com/"]
    ].map(fnPath("Exchanges Wallets"))
  },
  {
    type: "BROKERAGE & LIQUDITY PARTNERS",
    list: [
      ["Tagomi", "https://tagomi.com/"],
      ["B2C2", "https://www.b2c2.com/"],
      // ["LGO Markets", "https://lgo.group/"],
      ["CyberX", "https://www.cyberx.com"],
      ["Galaxy Digital", "https://www.galaxydigital.io/"],
      // ["Babel Finance", "https://babel.finance/"],
      // ["OmniEx", "https://omniex.io/"],
      ["FalconX", "https://FalconX.io/"]
    ].map(fnPath("Brokers Institutions"))
  },
  {
    type: "BLOCKCHAIN / MINING / DEFI",
    list: [
      ["DoraHacks", "https://dorahacks.com/"],
      // ["Lendf.Me", "https://www.lendf.me/"],
      ["IOTEX", "https://iotex.io/"],
      ["SWFT Coin", "https://www.swft.pro"],
      ["Dforce", "https://dforce.network/"],
      ["VeChain", "https://www.vechain.com/"],
      ["Poolin", "https://www.poolin.com/"]
    ].map(fnPath("Blockchain DeFi"))
  },
  {
    type: "STABLECOINS",
    list: [
      ["Paxos", "https://www.paxos.com/"],
      ["USDC", "https://www.circle.com/en/usdc"],
      ["USDK", "https://www.oklink.com/usdk"],
      ["HUSD", "https://www.stcoins.com/"]
    ].map(fnPath("Stablecoins"))
  },
  {
    type: "SECURITY & COMPLIANCE",
    list: [
      ["AnChain", "https://www.anchain.ai/"],
      ["CipherTrace", "https://ciphertrace.com/"],
      ["Aver", "https://goaver.com/"]
    ].map(fnPath("Tech and Security"))
  }
];
